// extracted by mini-css-extract-plugin
module.exports = {"reducer":"EntriesReducer_reducer__3D_MD","entry":"EntriesReducer_entry__ma5Ho"};